import * as React from "react";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {Accordion} from "shared/controls/Accordion/Accordion";

import {StoreBase} from "shared/utilities/Store/StoreBase";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {EventManager} from "shared/utilities/Events/EventManager";
import {UpdateFieldSettingsPanel} from "InternalShared/Events/UpdateFieldSettingsPanel";

@observer
export class FieldSettings extends React.Component<FieldSettingsProps, FieldSettingsState> {
    static defaultProps: Partial<FieldSettingsProps> = {};

    store:FieldSettingsStore;
    constructor(props: FieldSettingsProps) {
        super(props);
        this.state = {
            Item:null,
            Properties:[]
        };
        this.store=new FieldSettingsStore().Merge();
        this.Update=this.Update.bind(this);

        EventManager.Subscribe(UpdateFieldSettingsPanel,this.Update);
    }


    componentWillUnmount(): void {
        EventManager.UnsubscribeEvent(UpdateFieldSettingsPanel,this.Update)
    }

    public Update(){
        this.setState({
            Properties:this.state.Item?this.state.Item.GetProperties():[]
        });
    }

    public render() {
        return (
            <Accordion>
                {
                    this.state.Properties.map(group=>
                        <AccordionItem key={group.Label} Title={group.Label} IsOpen={true}>

                                {group.Properties.map((property,index)=>
                                    property.renderer(index.toString())
                                )}

                        </AccordionItem>
                    )
                }

            </Accordion>
        )
    }

    async FillPanel(Item: PDFControlBase):Promise<void> {
        return new Promise(resolve => {
            this.setState({
                Properties:Item?Item.GetProperties():[],
                Item:Item
            },resolve);
        })


    }
}

class FieldSettingsStore extends StoreBase{
    @observable
    public Text:string;
    protected LoadDefaultValues() {
        this.Text='asdf asdf';
    }

}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldSettingsProps {

}

interface FieldSettingsState {
    Item:PDFControlBase;
    Properties:GroupProperties[];
}

//#endregion "My Region"